/**
 * Auth API calls. Wraps apiClient with typed shapes.
 * Uses callWithRefresh so 401s auto-refresh on subsequent calls.
 */

import { callWithRefresh } from "./auth-flow";
import { endpoints } from "./endpoints";
import type { AuthResponse, LoginIn, LogoutIn, RefreshIn, RegisterIn, TokenPair, UserOut } from "./types";

export const authApi = {
  async register(payload: RegisterIn): Promise<AuthResponse> {
    return callWithRefresh<AuthResponse>(endpoints.auth.register, {
      method: "POST",
      body: payload,
    });
  },
  async login(payload: LoginIn): Promise<AuthResponse> {
    return callWithRefresh<AuthResponse>(endpoints.auth.login, {
      method: "POST",
      body: payload,
    });
  },
  async refresh(payload: RefreshIn): Promise<TokenPair> {
    // Refresh itself does not go through callWithRefresh to avoid loops.
    const { apiClient } = await import("./client");
    return apiClient<TokenPair>(endpoints.auth.refresh, {
      method: "POST",
      body: payload,
    });
  },
  async logout(payload: LogoutIn): Promise<void> {
    await callWithRefresh<void>(endpoints.auth.logout, {
      method: "POST",
      body: payload,
    });
  },
  async me(): Promise<UserOut> {
    return callWithRefresh<UserOut>(endpoints.users.me);
  },
};
